import { useRef, useCallback } from "react";

// This hook acts as a fire and forget callback that only runs once.
export const useCallbackOnce = (callback: () => void) => {
  const hasBeenCalled = useRef(false);
  const wrappedFunction = useCallback(() => {
    if (!hasBeenCalled.current) {
      hasBeenCalled.current = true;
      callback();
    }
  }, [callback]);
  wrappedFunction();
};
